import React, { useMemo, useState, useEffect } from "react";
import { DiPython, DiJava, DiJavascript1, DiPhp } from "react-icons/di";
import { SiR, SiCplusplus, SiTerraform, SiTensorflow, SiLatex } from "react-icons/si";
import { FaDatabase } from "react-icons/fa";
import { useTranslation } from "react-i18next";

// Import du composant réutilisable
import SkillSlider from "./SkillSlider"; 

// Import des médias
import htmlcss from "./media/html_css.webp";
import htmlcss_light from "./media/html_css_light.webp";
import amplLogo from "./media/ampl-logo.webp";

const TechstackSlider = () => {
  const { t } = useTranslation();
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    const onThemeChange = () => setTheme(localStorage.getItem("theme") || "dark");
    window.addEventListener("themeChanged", onThemeChange);
    return () => window.removeEventListener("themeChanged", onThemeChange);
  }, []);

  const categories = useMemo(
    () => [
      {
        label: t("cat_programming"),
        skills: [
          { icon: DiPython, name: "Python", libs: [t("skill_python_libs")] },
          { icon: SiR, name: "R", libs: [t("skill_r_libs")] },
          { icon: SiCplusplus, name: "C++", libs: [t("skill_cpp_libs")] },
          { icon: DiJava, name: "Java", libs: [t("skill_java_libs")] },
        ],
      },
      {
        label: t("cat_web"),
        skills: [
          { icon: DiJavascript1, name: "JavaScript", libs: [t("skill_js_libs")] },
          { icon: DiPhp, name: "PHP", libs: [t("skill_php_libs")] },
          { 
            image: theme === "dark" ? htmlcss : htmlcss_light, 
            name: "HTML & CSS", 
            libs: [t("skill_htmlcss_libs")] 
          },
        ],
      },
      {
        label: t("cat_db"),
        skills: [{ icon: FaDatabase, name: "SQL", libs: [t("skill_sql_libs")] }],
      },
      {
        label: t("cat_additional"),
        skills: [
          { icon: SiTensorflow, name: "Machine Learning", libs: ["scikit-learn, TensorFlow, PyTorch"] },
          { icon: SiTerraform, name: "Infrastructure", libs: [t("skill_infra_libs")] },
          { image: amplLogo, name: "AMPL", libs: [t("skill_ampl_libs")] },
          { icon: SiLatex, name: "LaTeX", libs: [t("skill_latex_libs")] },
        ],
      },
    ],
    [t, theme]
  );

  return (
    // On passe les catégories et le variant "primary"
    // Le composant SkillSlider s'occupe de faire le flatMap, le shimmer et le CSS cinématique.
    <SkillSlider data={categories} variant="primary" />
  );
};

export default TechstackSlider;